import Backbone from 'backbone'
import template from './edit-tree-dialog.hbs'
import i18n from 'scoreboard/components/i18n'
import _ from 'lodash'

var EditTreeDialog = Backbone.View.extend({

	className: 'edit-tree-dialog',

	render: function() {
		this.editTreeMenu = new this.EditTreeMenu({
			model: this.model,
			gardener: this.gardener
		})
		this.$el.empty().append(template(this.context()))
		this.$('.dialog-body-content').append(this.editTreeMenu.el)
		this.editTreeMenu.render()
		return this
	},

	context: function() {
		var title = '<q>' + _.escape(this.model.get('label')) + '</q>'
		title = i18n.get('common.edit2', title)
		return { title: title }
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.editTreeMenu], 'remove')
	}

})

export default EditTreeDialog

EditTreeDialog.__filename__ = 'components/edit-tree-dialog.js'
